import { ref, computed } from 'vue'

export interface File {
  id?: number
  name: string
  [key: string]: string | number | object | string[] | null | undefined
}

export function useFiles() {
  const files = ref<File[]>([]) // items is now Ref<Item[]>
  const projectFileList = ref<File[]>([])
  const getItems = async (): Promise<File[]> => {
    // return an empty array if we're running in a test environment
    return []

    // const response = await fetch('/api/list-files/?format=json')
    // // Assert the response is OK
    // if (!response.ok) {
    //   throw new Error('Failed to fetch Site')
    // }
    // // Assert the response is JSON
    // if (!response.headers.get('content-type')?.includes('application/json')) {
    //   // throw new Error('Invalid content type')
    // }

    // return await response.json()
  }

  const fetchFiles = async () => {
    files.value = await getItems()
    // remove any files prefixed with a dot
    console.log(files.value)
    files.value = files.value.filter(file => !file.name.startsWith('.'))
    console.log(files.value)
    // sort the sites by name

  }

  const fileKeys = computed(() => {
    return files.value.length > 0 ? Object.keys(files.value[0]) : []
  })

  const getProjectFileList = async (projectName: string): Promise<File[]> => {
    const response = await fetch(`/api/project-files/?project=${projectName}`)
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Site')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }
    return await response.json()
  }

  const fetchProjectFiles = async (projectName: string) => {
    const response = await getProjectFileList(projectName)
    console.log(response)
    // response should have a files property
    if (!response.files) {
      console.log('No files property in response')
      throw new Error('Invalid response')
    }

    // loop through each item in the response files array
    for (const item of response.files) {
      // item is probable just a string, check
      if (typeof item === 'string') {
        // if it is, log it
        console.log(item)
        // put it in our projectFileList
        if (item.startsWith('.')) {
          console.log('Skipping hidden file')
        } else {
          projectFileList.value.push({ name: item })
        }
      } else {
        // otherwise, log the name property
        console.log(item.name)
      }
    }
  }

  const projectFileKeys = computed(() => {
    return projectFileList.value.length > 0 ? Object.keys(projectFileList.value[0]) : []
  })

  return { files, fetchFiles, fileKeys, projectFileList, fetchProjectFiles, projectFileKeys }
}
